import { useEffect } from "react";

export default function NavbarOne(props) {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
   ""
  )
}